export const heroSlides = [
  {
    title: '欧冠决赛·巅峰对决',
    subtitle: '皇家马德里 vs 曼城',
    description: '欧洲冠军联赛决赛即将打响，双方实力势均力敌，精彩不容错过！注册即享专属赛事赔率。',
    cta: '立即注册',
    ctaLink: '/category/football',
    secondaryCta: '查看详情',
    secondaryCtaLink: '/article/ucl-final-preview',
  },
  {
    title: 'NBA新赛季·火热开启',
    subtitle: '全明星阵容蓄势待发',
    description: '2026赛季NBA常规赛全面开战，每日多场焦点对决，锁定开元体育获取第一手赛事资讯。',
    cta: '查看赛程',
    ctaLink: '/category/basketball',
    secondaryCta: '最新赔率',
    secondaryCtaLink: '/category/basketball',
  },
];

export const featuredEvents = [
  {
    id: 'evt-001',
    homeTeam: '皇家马德里',
    awayTeam: '曼城',
    homeOdds: '2.15',
    drawOdds: '3.40',
    awayOdds: '3.10',
    time: '2026-08-12 03:00',
    league: '欧洲冠军联赛',
    category: 'football',
    status: 'upcoming',
    homeScore: null,
    awayScore: null,
  },
  {
    id: 'evt-002',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeOdds: '1.85',
    drawOdds: null,
    awayOdds: '1.95',
    time: '2026-08-11 10:30',
    league: 'NBA常规赛',
    category: 'basketball',
    status: 'upcoming',
    homeScore: null,
    awayScore: null,
  },
  {
    id: 'evt-003',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeOdds: '1.72',
    drawOdds: null,
    awayOdds: '2.10',
    time: '2026-08-10 20:00',
    league: 'ATP大师赛',
    category: 'tennis',
    status: 'live',
    homeScore: 1,
    awayScore: 0,
  },
  {
    id: 'evt-004',
    homeTeam: 'T1战队',
    awayTeam: 'Gen.G',
    homeOdds: '2.30',
    drawOdds: null,
    awayOdds: '1.60',
    time: '2026-08-10 17:00',
    league: 'LCK夏季赛',
    category: 'esports',
    status: 'live',
    homeScore: 2,
    awayScore: 1,
  },
  {
    id: 'evt-005',
    homeTeam: '巴塞罗那',
    awayTeam: '马德里竞技',
    homeOdds: '1.90',
    drawOdds: '3.20',
    awayOdds: '4.00',
    time: '2026-08-13 04:00',
    league: '西班牙甲级联赛',
    category: 'football',
    status: 'upcoming',
    homeScore: null,
    awayScore: null,
  },
  {
    id: 'evt-006',
    homeTeam: '波士顿凯尔特人',
    awayTeam: '密尔沃基雄鹿',
    homeOdds: '1.65',
    drawOdds: null,
    awayOdds: '2.25',
    time: '2026-08-11 08:00',
    league: 'NBA常规赛',
    category: 'basketball',
    status: 'upcoming',
    homeScore: null,
    awayScore: null,
  },
];

export const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '采用国际领先的加密技术，保障用户资金与个人信息安全，持照经营值得信赖。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速结算',
    description: '赛事结束后秒级结算，提款快速到账，让您尽享流畅的体育娱乐体验。',
  },
  {
    icon: 'ri-global-line',
    title: '全球赛事',
    description: '覆盖全球200+体育赛事，每日数千场比赛，多元玩法满足不同需求。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '7x24客服',
    description: '专业客服团队全天候在线，多语言支持，随时为您解决任何问题。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端兼容',
    description: '支持PC、手机、平板全平台访问，随时随地畅享体育娱乐。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '会员特权',
    description: 'VIP会员享受专属赔率加成、生日礼金、优先客服等尊贵权益。',
  },
];

export const stats = [
  { value: '500万+', label: '注册用户' },
  { value: '200+', label: '覆盖国家' },
  { value: '50+', label: '体育项目' },
  { value: '99.9%', label: '安全率' },
];

export const latestArticles = [
  {
    id: 'ucl-final-preview',
    title: '2026欧冠决赛前瞻：皇马vs曼城，谁将问鼎欧洲之巅？',
    excerpt: '皇家马德里与曼城即将在欧冠决赛中相遇，两队历史上共交手12次，战绩旗鼓相当。本文将从战术、阵容、历史数据等角度全面分析这场巅峰对决。',
    category: '足球',
    categorySlug: 'football',
    date: '2026-08-07',
    readTime: '8分钟',
    imageSeq: 'article-ucl',
  },
  {
    id: 'nba-season-preview',
    title: 'NBA新赛季战力榜：湖人勇士领衔，谁能终结王朝？',
    excerpt: '随着新赛季的临近，各支球队经过休赛期的补强已全面就绪。湖人和勇士作为西部两大热门，谁能脱颖而出？我们为您带来完整的联盟战力分析。',
    category: '篮球',
    categorySlug: 'basketball',
    date: '2026-08-06',
    readTime: '12分钟',
    imageSeq: 'article-nba',
  },
  {
    id: 'esports-lck-summer',
    title: 'LCK夏季赛战报：T1险胜Gen.G，Faker再次证明传奇地位',
    excerpt: '在LCK夏季赛焦点战中，T1战队以2:1的比分险胜Gen.G，Faker选手凭借出色发挥率队获胜。本文回顾比赛精彩瞬间并展望后续赛程。',
    category: '电竞',
    categorySlug: 'esports',
    date: '2026-08-05',
    readTime: '6分钟',
    imageSeq: 'article-lck',
  },
  {
    id: 'tennis-alcaraz-rise',
    title: '阿尔卡拉斯：网坛新王的崛起之路与未来展望',
    excerpt: '年仅23岁的西班牙天才阿尔卡拉斯已斩获四座大满贯冠军，成为网坛新一代领军人物。回顾他的成长历程，展望这位天才少年的未来之路。',
    category: '网球',
    categorySlug: 'tennis',
    date: '2026-08-04',
    readTime: '10分钟',
    imageSeq: 'article-tennis',
  },
];

export const testimonials = [
  {
    name: '王先生',
    role: '资深足球爱好者',
    content: '开元体育的赔率非常有竞争力，结算速度快得惊人。我用了三年了，从来没有遇到过提款延迟的问题，强烈推荐！',
    rating: 5,
  },
  {
    name: '李先生',
    role: 'NBA球迷',
    content: '赛事覆盖面很广，从NBA到欧洲联赛都有，而且直播画质清晰流畅。客服响应也很快，体验很好。',
    rating: 5,
  },
  {
    name: '张先生',
    role: '电竞赛事玩家',
    content: '电竞赛事盘口丰富，LOL、DOTA2、CS2全都有。赔率更新及时，界面操作也很便捷，非常专业。',
    rating: 5,
  },
];